export default function AssignDriverModal({
  task,
  teamDrivers,
  allTeamDrivers,
  selectedAgentId,
  setSelectedAgentId,
  onClose,
  onAssign,
}) {
  const drivers = teamDrivers.length ? teamDrivers : allTeamDrivers;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center">
      <div className="bg-white p-4 rounded w-[90%] max-w-3xl">
        <h2 className="text-lg font-semibold mb-3">
          Assign Driver to {task?.order_id}
        </h2>

        <div className="grid grid-cols-3 gap-3">
          {drivers.map((d) => (
            <div
              key={d.driverId}
              onClick={() => setSelectedAgentId(d.driverId)}
              className={`p-3 border rounded cursor-pointer ${selectedAgentId === d.driverId ? "bg-orange-50 border-orange-500" : ""}`}
            >
              <p className="font-medium">{d.fullName}</p>
              <p className="text-xs text-gray-500">{d.dutyStatus}</p>
            </div>
          ))}
        </div>

        <div className="flex justify-end gap-3 mt-4">
          <button onClick={onClose} className="bg-gray-300 px-4 py-2 rounded">
            Cancel
          </button>
          <button
            onClick={() => onAssign(task.pk_task_id, selectedAgentId)}
            disabled={!selectedAgentId}
            className="bg-orange-500 text-white px-4 py-2 rounded disabled:opacity-50"
          >
            Assign
          </button>
        </div>
      </div>
    </div>
  );
}
